<template>
  <div
    class="header container bg-white mx-auto p-0"
    :id="route.name?.toString()">
    <div class="bg-white">
      <div class="container mx-auto pt-6 pb-4 sticky-padding-small">
        <div class="flex items-center justify-between h-16">
          <NuxtLink to="/"
            ><img
              class="logo"
              src="~/assets/images/logo_spring_green.png"
              alt="Spring Green Logo"
              loading="lazy"
          /></NuxtLink>
          <client-only>
            <div class="flex items-center justify-end flex-wrap h-16">
              <div class="flex flex-nowrap gap-1 items-center me-4">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 22 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="inline-block icon-location">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                    fill="#517185" />
                  <mask
                    id="mask0"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="22"
                    height="28">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                      fill="white" />
                  </mask>
                  <g mask="url(#mask0)"></g>
                </svg>
                <span class="font-semibold" v-if="bLocation">
                  {{ bLocation }}
                </span>
              </div>
              &nbsp;
              <a
                class="text-gray-500 font-bold flex flex-nowrap gap-1 items-center"
                :href="contactPhoneUrl"
                v-if="contactPhone">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167 3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167 9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z"
                    fill="#517185" />
                </svg>
                <span>{{ displayContactPhone }}</span></a
              >
            </div>
          </client-only>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatPhoneNumber, getPhoneHref } from "~/utils/phone";

const route = useRoute();

const props = defineProps({
  bLocation: String,
  contactPhone: String,
});

const displayContactPhone = computed(
  () => formatPhoneNumber(props.contactPhone) ?? props.contactPhone,
);
const contactPhoneUrl = computed(() => getPhoneHref(props.contactPhone) ?? undefined);
</script>

<style scoped>
.header {
  /* border-bottom: 1px solid #b9b9b9; */
  position: relative;
  z-index: 200;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #517185;
  opacity: 0.9;
  /* Firefox */
}

.mobile a {
  font-weight: 600;
  display: block;
}

.logo {
  width: 260px;
  aspect-ratio: 762 / 183;
}

@media (max-width: 1180px) {
  .logo {
    width: 180px;
    aspect-ratio: 762 / 183;
  }
}

@media (max-width: 1120px) AND (min-width: 1024px) {
  .menu a {
    font-size: 13px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (max-width: 640px) {
  .logo {
    width: 120px;
  }
}

/* Mobile Sticky styles*/
@media screen and (max-width: 1023px) {
  .header {
    position: sticky;
    top: -1px;
    transition: all 0.2s ease-in-out;
  }

  .header.is-sticky .sticky-padding-small {
    padding: 0.25em 3%;
  }

  .header .sticky-padding-small {
    transition: all 0.2s ease-in-out;
  }
}
</style>
